<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Rit kopiëren</h1>
<div mat-dialog-content>
  <form (ngSubmit)="copy()" [formGroup]="copyForm">
    <mat-form-field>
      <mat-label>Frequentie</mat-label>
      <mat-select formControlName="type" required>
        <mat-option value="weekly">Wekelijks</mat-option>
        <mat-option value="everyotherweek">Om de week</mat-option>
        <mat-option value="monthly">Maandelijks</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Aantal kopieën</mat-label>
      <input formControlName="times" type="number" autocomplete="off" min="1" step="1" matInput required />
      @if (copyForm.controls.times.invalid) {
        <mat-error>Het aantal kopieën moet minstens 1 zijn.</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Einddatum</mat-label>
      <input matInput [formControl]="copyForm.controls.endDate" [matDatepicker]="endDate" />
      <mat-datepicker-toggle matIconSuffix aria-label="Kalender openen" [for]="endDate"></mat-datepicker-toggle>
      <mat-datepicker #endDate></mat-datepicker>
      <mat-hint>De rit kan maximaal 2 jaar vooruit worden herhaald.</mat-hint>
      @if (copyForm.controls.endDate.hasError('maxDateExceeded')) {
        <mat-error>De einddatum mag niet later zijn dan {{ moment().add(2, 'year').format('DD-MM-YYYY') }}.</mat-error>
      }
    </mat-form-field>
  </form>
  @if (dateSequence().length > 0 || rebuildingSequence()) {
    <div class="date-sequence-wrapper">
      <div class="date-sequence-title">Datumreeks</div>
      @if (!rebuildingSequence()) {
        <mat-chip-listbox>
          @for (dateString of dateSequence().slice(0, 4); track dateString) {
            <mat-chip [class.date-warning]="hasWarning(dateString)" [matTooltip]="warnings()[dateString]?.message">
              {{ dateString }}
            </mat-chip>
          }
          @if (dateSequence().length > 4) {
            <div class="chip-overflow">...</div>
          }
        </mat-chip-listbox>
        @if (dateSequence().length > 4) {
          <div class="view-more-wrapper">
            <button mat-flat-button class="secondary-color" (click)="viewDateSequence()">Bekijk alle datums</button>
          </div>
        }
      } @else if (rebuildingSequence()) {
        <div class="loading-sequence">
          <mat-spinner diameter="30"></mat-spinner>
        </div>
      }
    </div>
  } @else if (dateSequence()?.length === 0 && !rebuildingSequence()) {
    <p>Er kunnen geen ritkopieën gemaakt worden met de gekozen opties en/of einddatum.</p>
  }
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false" [disabled]="copyInProgress()" [class.spinner]="copyInProgress()">
    Annuleren
  </button>
  <button
    mat-flat-button
    [disabled]="copyDisabled()"
    (click)="copy()"
    color="primary"
    [class.spinner]="copyInProgress()"
  >
    Kopieën maken
  </button>
</div>
